// SPDX-License-Identifier: Apache-2.0
"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var BalanceProofs_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.BalanceProofs = exports.BalanceProof = exports.Balance = void 0;
const ethers_1 = require("ethers");
const typedjson_1 = require("../../export/typedjson");
const util_1 = require("../util");
const assets_1 = require("../../ledger/assets");
const ledger_1 = require("../../ledger");
const api_1 = require("./..");
const api_2 = require("./..");
const balanceProofsTypeName = "BalanceProofs";
// Balance is the value of funds for the account within epoch.
let Balance = class Balance {
    constructor(epoch, account, exit, values) {
        this.epoch = epoch;
        this.account = ledger_1.Address.ensure(account);
        this.exit = exit;
        this.values = values;
    }
    // (uint64,address,bool,tuple(address,bytes)[])
    asABI() {
        return {
            epoch: this.epoch.valueOf(),
            account: this.account.toString(),
            exit: this.exit,
            tokens: this.values.asABI(),
        };
    }
    packTagged(contract) {
        return new util_1.ABIEncoder(["uint64", this.epoch], this.account, this.exit, this.values).pack("ErdstallBalance", contract);
    }
    async sign(contract, signer) {
        const sig = await signer.signMessage(this.packTagged(contract).keccak256());
        return new BalanceProof(this, new api_1.Signature(sig));
    }
};
__decorate([
    typedjson_1.jsonBigIntMember(),
    __metadata("design:type", typeof BigInt === "function" ? BigInt : Object)
], Balance.prototype, "epoch", void 0);
__decorate([
    typedjson_1.jsonMember(ledger_1.Address),
    __metadata("design:type", ledger_1.Address)
], Balance.prototype, "account", void 0);
__decorate([
    typedjson_1.jsonMember(Boolean),
    __metadata("design:type", Boolean)
], Balance.prototype, "exit", void 0);
__decorate([
    typedjson_1.jsonMember(() => assets_1.Assets),
    __metadata("design:type", assets_1.Assets)
], Balance.prototype, "values", void 0);
Balance = __decorate([
    typedjson_1.jsonObject,
    __metadata("design:paramtypes", [typeof BigInt === "function" ? BigInt : Object, Object, Boolean, assets_1.Assets])
], Balance);
exports.Balance = Balance;
// A BalanceProof is generated by the Enclave at the end of each transaction
// phase for each account in the Erdstall system.
let BalanceProof = class BalanceProof {
    constructor(balance, signature) {
        this.balance = balance;
        this.sig = signature;
    }
    toEthProof() {
        return [this.balance.asABI(), this.sig.value];
    }
    verify(contract, tee) {
        const signer = ethers_1.utils.verifyMessage(this.balance.packTagged(contract).keccak256(), this.sig.toString());
        return signer === tee.toString();
    }
};
__decorate([
    typedjson_1.jsonMember(Balance),
    __metadata("design:type", Balance)
], BalanceProof.prototype, "balance", void 0);
__decorate([
    typedjson_1.jsonMember(api_1.Signature),
    __metadata("design:type", api_1.Signature)
], BalanceProof.prototype, "sig", void 0);
BalanceProof = __decorate([
    typedjson_1.jsonObject,
    __metadata("design:paramtypes", [Balance, api_1.Signature])
], BalanceProof);
exports.BalanceProof = BalanceProof;
let BalanceProofs = BalanceProofs_1 = class BalanceProofs extends api_2.ErdstallObject {
    constructor() {
        super();
        this.map = new Map();
    }
    static toJSON(me) {
        var obj = {};
        me.map.forEach((bp, addr) => {
            obj[addr] = JSON.parse(typedjson_1.TypedJSON.stringify(bp, BalanceProof));
        });
        return obj;
    }
    static fromJSON(data) {
        const bps = new BalanceProofs_1();
        for (const addr in data) {
            bps.map.set(addr, typedjson_1.TypedJSON.parse(JSON.stringify(data[addr]), BalanceProof));
        }
        return bps;
    }
    objectType() {
        return BalanceProofs_1;
    }
    objectTypeName() {
        return balanceProofsTypeName;
    }
};
BalanceProofs = BalanceProofs_1 = __decorate([
    typedjson_1.jsonObject,
    __metadata("design:paramtypes", [])
], BalanceProofs);
exports.BalanceProofs = BalanceProofs;
api_2.registerErdstallType(balanceProofsTypeName, BalanceProofs);
util_1.customJSON(BalanceProofs);
//# sourceMappingURL=balanceproof.js.map